<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-12-09 16:34:53
 * @LastEditors: yd
 * @LastEditTime: 2020-12-10 09:41:52
-->
<template>
  <v-chip v-on="$listeners" v-bind="$attrs" class="box">
    <slot></slot>
  </v-chip>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {},
  methods: {},
}
</script>

<style scoped>
.v-size--large {
  line-height: 54px;
}
.v-size--default {
  line-height: 32px;
}
.v-size--small {
  line-height: 24px;
}
.box /deep/ .v-chip__content {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  max-width: 248px !important;
  display: inline-block;
}
</style>
